<div class="main-container">
  <div class="close">
    <button class="close-btn" (click)="closeDialog()">
      <span class="close-btn__line"></span>
      <span class="close-btn__line"></span>
    </button>
  </div>

  <div class="bonus-reward">
    <div class="image-container">
      <img src="assets/images/cross-sell-dep-pop.png" alt="lemon image" class="reward-image">
    </div>
    
    <span class="reward-text">{{ data.translations?.your }} <span class="reward-pointer">{{ totalPrizeAmount }} {{ currencySymbol }}</span> {{ data.translations?.bonusActive }}</span>
  </div>

  <div class="glow"></div>
  <img class="background-extra-confetti" [ngClass]="{'mobile': !isDesktop}" src="assets/images/cross-sell-extra-confetti.png" alt="confetti">
  
  <div class="main-content">
    <p class="capture-text">{{ data.translations?.craving }}</p>

    <div class="image-box">
      <img src="assets/images/cross-sell-box-star.png" alt="win box image">
    </div>

    <div class="proposition-box">
      <!-- <p class="proposition-text">{{ data.translations?.makeDeposit }}</p> -->
      
      <div class="amount-value" *ngIf="isReadyGamification">
        <p class="percentage">{{ userGamificationLevel }}%</p>
        <p class="amount-text">{{ data.translations?.upTo | uppercase}} {{ userGamificationAmount }}{{ currencySymbol }}</p>
      </div>

      <p class="exclusive-bonus">{{ data.translations?.exclusiveBonus }}</p>
    </div>
  </div>

  <div class="bottom-container">
    <button round-button filled="filled" color="accent" class="confirm-btn" [ngClass]="{'mobile': !isDesktop}" (click)="redirectToDeposit()">{{ data.translations?.depositNow }}</button>

    <div class="min-deposit">
      <p>{{ data.translations?.requiredDeposit1 }} {{ baseMinDepositAmount * currencyValue }} {{ currencySymbol }} - {{ data.translations?.requiredDeposit2 }}</p>
    </div>

    <div class="decline-bonus" (click)="closeDialog()">
      <p>{{ data.translations?.declineBtn }}</p>
    </div>
  </div>
</div>